import React, { useState } from "react";
import "./Footer.css";
import logo from "../assets/logo.png";

import facebookIcon from "../assets/facebook.png";
import twitterIcon from "../assets/twitter.png";
import linkedinIcon from "../assets/linkedin.png";

export default function Footer() {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    setEmail("");
    alert("Thanks! Newsletter signup captured.");
  };

  return (
    <footer id="footer" className="ibsFooterOuter">
      <section className="ibsFooterPanel">
        <div className="container ibsFooterTop">
          {/* Left / Information */}
          <div className="fBlock fInfo">
            <img src={logo} alt="IBS Logo" className="fLogo" />

            <p className="fTagline">
              We successfully cope with tasks of varying complexity, provide long-term
              guarantees and regularly master new technologies.
            </p>
          </div>

          {/* Contact */}
          <div className="fBlock">
            <h3 className="fHead">Contact</h3>

            <div className="fContactRow">
              <span className="fIcon" aria-hidden="true">📍</span>
              <div className="fContactText">
                Door 408, Pavani Anasuya Towers, Tarnaka, Hyderabad - 500007
              </div>
            </div>

            <div className="fContactRow">
              <span className="fIcon" aria-hidden="true">📞</span>
              <div className="fContactText">
                +91 903 06 45554 <br />
                +91 903 07 45554
              </div>
            </div>

            <div className="fContactRow">
              <span className="fIcon" aria-hidden="true">✉️</span>
              <a className="fEmail" href="mailto:info@ibs.ind.in">
                info@ibs.ind.in
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div className="fBlock">
            <h3 className="fHead">Newsletter</h3>
            <p className="fText">Signup for our weekly newsletter to get the latest news.</p>

            <form className="newsletter" onSubmit={onSubmit}>
              <input
                className="newsInput"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email."
              />
              <button className="newsBtn" type="submit" aria-label="Subscribe">
                <span className="newsBtnShape" aria-hidden="true" />
              </button>
            </form>
          </div>
        </div>

        {/* Bottom legal strip */}
        <div className="ibsBottomStrip">
          <div className="container bottomRow">
            {/* LEFT */}
            <div className="bottomDeveloped">
              Developed by{" "}
              <a
                className="aurum"
                href="https://vrnd.tech/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit VRND Business Solutions"
              >
                VRND Business Solutions
              </a>
            </div>

            {/* CENTER */}
            <div className="bottomCopyright">
              © {year} <span className="ibsWord">IBS</span> All rights reserved
            </div>

            {/* RIGHT */}
            <div className="bottomRight" aria-label="Social links">
              <a
                className="socialIconLink"
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img className="socialIcon" src={facebookIcon} alt="Facebook" />
              </a>

              <a
                className="socialIconLink"
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <img className="socialIcon" src={twitterIcon} alt="Twitter" />
              </a>

              <a
                className="socialIconLink"
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <img className="socialIcon" src={linkedinIcon} alt="LinkedIn" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}
